import * as React from 'react';

import * as styles from './styles.css';
import { AboutReportContainer } from '../../../../containers/AboutReportContainer';
import { OurEstimatorsContainer } from '../../../../containers/OurEstimatorsContainer';
import { PrevEstimationsContainer } from '../../../../containers/PrevEstimationsContainer';
import { RequestPushSettingsContainer } from '../../../../containers/RequestPushSettingsContainer';
import { StickyFooterContainer } from '../../../../containers/StickyFooterContainer';
import { TopMobileBanner } from '../../../../containers/TopMobileBanner';
import { ValuationFiltersMobileContainer } from '../../../../containers/ValuationFiltersContainer';
import { ValuationFormModalOpenerContainer } from '../../../../containers/ValuationFormModalOpenerContainer';
import { checkHasData, useEstimationHistoryQuery } from '../../../../serverState/estimationHistory';
import { HowItWorks } from '../../../HowItWorks';
import { InWebview } from '../../../InWebview';
import { MobileHeroBanner } from '../../../MobileHeroBanner';
import { MobileSection } from '../../../MobileSection';
import { OurNumbers } from '../../../OurNumbers';
import { useStickyFooterControl } from '../../utils/useStickyFooterControl';

export const MobileViewC = () => {
  const { data } = useEstimationHistoryQuery();
  const hasPrevEstimations = React.useMemo(() => checkHasData(data), [data]);
  const { btnOnPageInViewRef } = useStickyFooterControl();

  return (
    <>
      <TopMobileBanner />
      <MobileSection className={styles['container']}>
        <MobileHeroBanner textColor="black_100" />
        {!hasPrevEstimations && (
          <ValuationFormModalOpenerContainer
            btnOnPageInViewRef={btnOnPageInViewRef}
            className={styles['open_form_button']}
          />
        )}
        <PrevEstimationsContainer textColor="black_100" />
        <OurEstimatorsContainer className={styles['our_estimators']} />
        <AboutReportContainer className={styles['about_report']} />
      </MobileSection>
      <MobileSection className={styles['our_numbers']}>
        <OurNumbers />
      </MobileSection>
      <MobileSection className={styles['end']}>
        <HowItWorks className={styles['how_it_works']} />
      </MobileSection>
      <StickyFooterContainer />
      <ValuationFiltersMobileContainer />
      <InWebview>
        <RequestPushSettingsContainer />
      </InWebview>
    </>
  );
};
